export default class AlertDomainService {
    static get StaffInitiatedAlertId() {
        return 4;
    }
}
